module.exports = __webpack_public_path__ + "static/media/szekesfehervar-biztber-projektmenedzsment.6868577a.jpg";